import { render } from "./LinkDownMessage.vue?vue&type=template&id=efbb4736&scoped=true"
import script from "./LinkDownMessage.vue?vue&type=script&lang=js"
export * from "./LinkDownMessage.vue?vue&type=script&lang=js"

import "./LinkDownMessage.vue?vue&type=style&index=0&id=efbb4736&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbb4736"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
